import {ShouldSkipLazyLoadFn} from 'app/interface';
import {getConfigByComponentName} from 'app/utils/config/getConfigByComponentName';
import {HeaderNavigationConfig} from 'interfaces/structure/components/headerNavigationConfig';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn = () => {
    const config: HeaderNavigationConfig = getConfigByComponentName('mobile-header');
    return config?.general.userLoginConfiguration ? 'LOAD_EAGER' : 'LOAD_LAZY';
};
